<template>
  <div class="card-cont">
    <div class="card-in">
      <div class="card-header">
        <div class="card-header-in">
          <div class="icon" :style="{'background-color': iconColor}">
						<slot name="icon"></slot>
          </div>
          <div class="card-title">
						<slot name="title"></slot>
					</div>
        </div>
      </div>

			<div style="padding: 12px">
				<slot></slot>
			</div>
    </div>
  </div>
</template>

<script>
export default {
	props: ['iconBg', 'cardName'],
	computed: {
		iconColor () {
			return this.iconBg ? this.iconBg : '#866b93';
		}
	}
}
</script>

<style lang="scss" scoped type="text/css">
.card-cont{
	padding: 26px 0 10px 0;
	box-sizing: border-box;
	max-width: 800px;
	margin: 0 auto;
}
.card-in{
	border-radius: 4px;
	background-color: #fff;
	box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}
// 卡片
.card-header{
	height: 70px;
	position: relative;
	box-sizing: border-box;
	padding: 0 20px;
	.card-header-in{
		position: absolute;
		left: 0;
		bottom: 0px;
		width: 100%;
		box-sizing: border-box;
		padding: 0 12px;
		display: flex;
		.icon{
			box-sizing: border-box;
			padding: 28px;
			line-height: 32px;
			height: 88px;
			min-width: 88px;
			text-align: center;
			color: #ffffff;
			background-color: #866b93;
			border-radius: 4px;
			font-weight: 700;
			box-shadow: 0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)!important;
			.v-icon{
				color: #fff;
			}
		}
		.card-title{
			box-sizing: border-box;
			flex: 10;
			padding: 24px 12px 0 12px;
			font-weight: 300;
			text-align: right;
		}
	}
}
</style>